<template>
  <div class="alert alert-info panel-filter-1">
    <p>پنل</p>
    <div class="" v-for="panel in panels">
      <div class="form-check">
        <input v-model="selectedPanels" class="form-check-input" type="checkbox" :value="panel.id"
               :id="`panel_${generateHash()}_${panel.id}`">
        <label class="form-check-label my-2 mr-3" :for="`panel_${generateHash()}_${panel.id}`">
          {{ panel.name }}
        </label>
      </div>

    </div>
  </div>
</template>


<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import {mapGetters} from "vuex";

export default {
  name: "PanelFilter",
  data() {
    return {
      selectedPanels: []
    }
  },
  computed: {
    ...mapGetters({
      panels: "Language/getPanels"
    })
  },
  methods: {
    generateHash,
  },
  mounted() {
  },
  watch: {
    selectedPanels: {
      handler(oldValue, newValue) {
        this.$emit('updateFilter', {panels: this.selectedPanels})
      }
    }
  },
}
</script>

<style scoped></style>
